import ptaxMetadata from './data/metadata.json';
import type { PtaxDataVersion } from './types.js';

export const PTAX_DATA_VERSION: PtaxDataVersion = ptaxMetadata as PtaxDataVersion;
